import React, { useEffect, useRef, useState } from "react";
import Modal from "@/components/Modal";
import { useTranslation } from "@/langs/useTranslation";
import MemoedHOC from "@/hoc/MemoedHOC";
import SingleSelector from '@/components/SingleSelector';
import { toast } from "@/helpers/toast"

function TranserModal({ open, value, onSelect, onConfirm, onClose }) {
  const { t } = useTranslation();
  const [selected, setSelected] = useState([]);

  const handleConfirm = () => {
    if (!selected.length) {
      toast.info(t({ defaultMessage: "请选择一个门店状态" }));
      return;
    }
    return onConfirm?.(
      selected
    );
  };

  const handleChange = e => {
    const { value } = e.target;
    setSelected(value);
    onSelect?.(
      value
    );
  };

  useEffect(() => {
    if (!open) {
      setSelected([]);
    }
  }, [open]);

  useEffect(() => {
    if (value) {
      setSelected(value);
    }
  }, [value]);

  return (
    <Modal
      title={t({ defaultMessage: "更新状态" })}
      open={open}
      onClose={onClose}
      onConfirm={handleConfirm}
      className="StoreUpdateStatusModal"
    >
      <div class="subTitle">{t({ defaultMessage: "是否将选择的门店状态改为" })}</div>
      <SingleSelector
        placeholder={t({ defaultMessage: "选择门店状态" })}
        options={[
          { name: t({ defaultMessage: "未开业" }), id: "0" },
          { name: t({ defaultMessage: "营业" }), id: "1" },
          { name: t({ defaultMessage: "停业" }), id: "2" },
          { name: t({ defaultMessage: "闭店" }), id: "3" }
        ]}
        clearable
        name="StoreUpdateStatus"
        initialValue=""
        value={selected}
        onChange={handleChange}
      />
    </Modal>
  );
}

export default MemoedHOC(TranserModal);
